module.exports = __webpack_public_path__ + "static/media/HN.4ab02d31.png";